// extracted by mini-css-extract-plugin
export default {"container":"commonTable_container__D9lCr","title":"commonTable_title__I07Gw"};